import axios from 'ps-components/lib/apiClient';
import { useQuery } from "react-query";
import { SearchFilter, VectorSearchFilters } from '../../lib/types';
import { useSession } from "../redux";


const fetchSearchFilters = async (currency: string, selectedFilters:VectorSearchFilters, maid:string): Promise<SearchFilter> => {
    
    const publishers = selectedFilters?.publisher ? selectedFilters.publisher : null;
    const results = await axios.apiPost(`/cms/api/accounts/${maid}/filters/type-ahead-filters`,
      {currencies:[currency],
       restrictSurveysToPublishers:publishers
      }
    );
    const data = results.data?.data
    const searchFilters = ({ ...data, surveyCodeSurveyShortName: data.surveyCodeSurveyShortName?.map((s: { surveyShortName: string, surveyCode: string }) => `${s.surveyShortName} - ${s.surveyCode}`)})
    return searchFilters
  }

  export const useTypeAheadFilters = (currency:string, selectedFilters: VectorSearchFilters) => {
  const session = useSession();
  const maid = session.organization.masterAccountId
  const query = useQuery(['type-ahead-filters', {currency, publisher: selectedFilters?.publisher}], () => fetchSearchFilters(currency, selectedFilters, maid) , { staleTime: Infinity })
  return query;
  }
